<template>
  <date-range-picker 
    v-model="value"
    :locale-data="{ firstDay: 1, format: 'mm/dd/yyyy' }"
    :ranges="false">
    <template #input="picker">
      <a class="btn btn-white no-margin">
        <div class="grid-x align-middle">
          <div class="cell shrink">
            <span v-html="$icons.get('calendar', 'large')" style="margin-right:.3rem"></span>
          </div>
          <div class="cell auto">
            {{ picker.startDate | date }} - {{ picker.endDate | date }}
          </div>
        </div>
      </a>
    </template>
  </date-range-picker>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import dayjs from 'dayjs'

export default { 
  name: 'DateRangeFilter',
  components: {
    DateRangePicker
  },
  props: {
    dateRange: {
      type: Object,
      required: true
    }
  },
  filters: {
    date (val) {
      let dt = dayjs(val)
      return val ? dt.format('MMMM D, YYYY') : ''
    }
  },
  computed: {
    value: {
      get() {
        return this.dateRange
      },
      set(val) {
        this.$emit('apply-filter', {
          name: 'date_range',
          data: {
            startDate: dayjs(val.startDate).format('YYYY-MM-DD'),
            endDate: dayjs(val.endDate).format('YYYY-MM-DD')
          }
        })
      }
    }
  }
}
</script>
